import React, { FC, useContext, useState } from 'react';
import { useTranslation } from 'react-i18next';
import BlankPage from '../../../../Components/Layout/BlankPage';
import LoadingButton from '../../../../Components/Button/LoadingButton';
import { UserContext } from '../../../../Vendor/Context/UserContextProvider';
import { BannerContext } from '../../../../Vendor/Context/BannerContextProvider';
import User from '../../../../Entity/User';
import FormEmpty from '../../../../Vendor/Components/FormEmpty';

const QuotaPage: FC = () => {
    const { t } = useTranslation();
    const [isLoading, setIsLoading] = useState<boolean>(false);
    const [reloadKey, setReloadKey] = useState<number>(0);
    const { currentUser, setCurrentUser } = useContext(UserContext);
    const { setBanner } = useContext(BannerContext);

    const onSubmit = () => {
        setIsLoading(true);
    };

    const onResponse = () => {
        setIsLoading(false);
    };

    const onSuccess = (data: User) => {
        setBanner({ type: 'success', i18nTitle: 'app.save', i18nMessage: 'app.data_saved_message' });
        if (data) {
            setCurrentUser(data);
        }
        setReloadKey((prev) => prev + 1);
    };

    if (!currentUser || !currentUser.currentOrganization) return <></>;

    return (
        <BlankPage>
            <FormEmpty
                key={reloadKey}
                path={'/admin/edition/ai/quota'}
                formPath={!!currentUser?.currentOrganization?.id}
                children={
                    <div className="row justify-content-end align-items-center">
                        <div className="col-auto">
                            <LoadingButton type="submit" isLoading={isLoading}>
                                {t('app.validate')}
                            </LoadingButton>
                        </div>
                    </div>
                }
                method={'PATCH'}
                onSuccess={onSuccess}
                onSubmit={onSubmit}
                onResponse={onResponse}
            />
        </BlankPage>
    );
};

export default QuotaPage;
